import NetInfo from '@react-native-community/netinfo';
import { ImageSourcePropType } from 'react-native';
// import { postAppEventAPi } from '../api/events/eventsApi';
import { IFeedLongVideoData } from '../api/kisaan/interface';
import { AppDetails, EventParam } from '../interface/videoPlaybackEvent';
import { IlongVideo } from '../store/interface';
// import { analytics } from '../../../nc-nk-web-deps/src/firebase/analytics';
// import { logFacebookEvent } from '../fbsdk/fbsdk';
import { NetWorkDetails } from '@ninjacart/nc-nk-core';
import { KissanEventType } from './eventConstants';
import { logFacebookEvent } from '../fbsdk/fbsdk';
import { logEvent } from '@ninjacart/nc-nk-firebase';

// const userStore = useProfileStore.getState();

export const getShortsPreviewUrl = (video: IlongVideo): ImageSourcePropType => {
  if (video?.card?.image) {
    return { uri: video.card.image };
  } else if (video?.media_attachments?.length > 0) {
    return { uri: video?.media_attachments?.[0].preview_url };
  } else {
    return { uri: 'https://codyhouse.co/web/assets/img/nuggets/preview/image-clipping-effect.png' };
  }
};
interface CustomImageSourcePropType {
  uri: string;
  type?: string; // You can include the type property here
}
export const getLongVideoPreviewUrl = (video: IlongVideo): CustomImageSourcePropType[] => {
  const sources: CustomImageSourcePropType[] = [];
  if (video?.card?.image) {
    sources.push({ uri: video.card.image, type: 'video' });
  }
  if (video?.media_attachments?.length > 0) {
    const previewUrl = video.media_attachments[0].preview_url;
    if (Array.isArray(previewUrl)) {
      sources.push(...previewUrl.map((url) => ({ uri: url, type: 'image' })));
    } else if (typeof previewUrl === 'string') {
      sources.push({ uri: previewUrl, type: 'image' });
    }
  }
  if (sources.length === 0) {
    sources.push({
      uri: 'https://codyhouse.co/web/assets/img/nuggets/preview/image-clipping-effect.png',
      type: 'video',
    });
  }
  return sources;
};

export const getLongVideoStreamingUrl = (
  video: IFeedLongVideoData
): CustomImageSourcePropType[] => {
  const sources: CustomImageSourcePropType[] = [];
  if (video?.card?.image) {
    sources.push({ uri: video.card.image, type: 'video' });
  }
  if (video?.streamingPlaylists?.length > 0) {
    const previewUrl = video?.streamingPlaylists?.[0]?.playlistUrl;
    if (Array.isArray(previewUrl)) {
      sources.push(...previewUrl.map((url) => ({ uri: url, type: 'image' })));
    } else if (typeof previewUrl === 'string') {
      sources.push({ uri: previewUrl, type: 'image' });
    }
  }
  if (sources.length === 0) {
    sources.push({
      uri: 'https://codyhouse.co/web/assets/img/nuggets/preview/image-clipping-effect.png',
      type: 'video',
    });
  }
  return sources;
};
export const msToTime = (duration: number) => {
  const seconds = Math.floor(duration / 1000);
  return seconds;
};

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const posthogAdditionalDetails = (
  eventParams: EventParam[]
): { [key: string]: string | number } => {
  const convertedObject: { [key: string]: string | number } = {};
  eventParams.forEach((item) => {
    const key = `${item.refType}_eventparams`;
    const value = item.refValue.refValueInt ?? item.refValue.refValueString ?? '';
    convertedObject[key] = value;
  });
  return convertedObject;
};

export const getNetworkDetails = (): Promise<EventParam[]> => {
  return NetInfo.fetch().then((state) => {
    const networkDetails: NetWorkDetails = {
      isConnected: state?.isConnected ?? false,
      isWifiEnabled: state?.isWifiEnabled,
      type: state?.type ?? '',
    };
    return [
      {
        refType: 'isConnected',
        refValue: {
          refValueString: networkDetails.isConnected ? 'true' : 'false',
        },
      },
      {
        refType: 'isWifiEnabled',
        refValue: {
          refValueString: networkDetails.isWifiEnabled ? 'true' : 'false',
        },
      },
      {
        refType: 'type',
        refValue: {
          refValueString: networkDetails.type,
        },
      },
    ];
  });
};

export const normalizeTextContent = (content: string, showFullContent: boolean): string => {
  let conCatContent;
  if (!content) return '';
  if (showFullContent) {
    conCatContent = content.replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '');
  } else {
    conCatContent =
      content
        .replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '')
        .replace(/-ff9e-48bd-9f18-f95d99d2d53a/g, '')?.length > 100
        ? content
            .replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '')
            .replace(/-ff9e-48bd-9f18-f95d99d2d53a/g, '')
            ?.substring(0, 100) + '...'
        : content
            ?.replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '')
            .replace(/-ff9e-48bd-9f18-f95d99d2d53a/g, '');
  }
  return conCatContent;
};

export const truncateName = (name, size) => {
  if (name && name.length > size) {
    return name.substring(0, size) + '...';
  }
  return name;
};

export const interpolate = (translationText, replacementsObj) => {
  const interpolatedText = translationText.replace(
    /{(\w+)}/g,
    (placeholderWithDelimiters, placeholderWithoutDelimiters) =>
      replacementsObj.hasOwnProperty(placeholderWithoutDelimiters)
        ? replacementsObj[placeholderWithoutDelimiters]
        : placeholderWithDelimiters
  );
  return interpolatedText;
};

export const toHHMMSS = (secs: number): string => {
  const sec_num = secs;
  const hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor(sec_num / 60) % 60;
  const seconds = Math.round(sec_num % 60);

  return [hours, minutes, seconds]
    .map((v) => (v < 10 ? '0' + v : v))
    .filter((v, i) => v !== '00' || i > 0)
    .join(':');
};

export const fetchVideoMetadata = async (
  uri: string
): Promise<{
  fileSize: number;
  mimeType: string | null;
  width: number;
  height: number;
  uri: string;
  fileName: string;
}> => {
  try {
    const response = await fetch(uri);
    const blob = await response.blob();

    const fileSize = blob.size;
    const mimeType = blob.type;

    const videoUrl = URL.createObjectURL(blob);
    const videoElement = document.createElement('video');

    return new Promise((resolve) => {
      videoElement.onloadedmetadata = () => {
        const width = videoElement.videoWidth;
        const height = videoElement.videoHeight;
        URL.revokeObjectURL(videoUrl); // Clean up the object URL
        resolve({
          fileSize,
          mimeType,
          width,
          height,
          uri,
          fileName: uri.split('/').pop() || `video_${Date.now()}`,
        });
      };
      videoElement.src = videoUrl;
    });
  } catch (error) {
    console.error('Error fetching video metadata:', error);
    return {
      fileSize: 0,
      mimeType: null,
      width: 0,
      height: 0,
      uri,
      fileName: uri.split('/').pop() || `video_${Date.now()}`,
    };
  }
};

export const sendToFirebasEvents = [
  KissanEventType.QNA_ASKSUBMIT_SUCCESS,
  KissanEventType.ITEM_LIKED,
  KissanEventType.SELECT_POST,
  KissanEventType.ITEM_COMMENT,
  KissanEventType.AUTO_PLAY_VIDEO_PLAY,
  KissanEventType.AUTO_VIDEO_PLAY_VIDEO_PROGRESS_ONE,
  KissanEventType.AUTO_PLAY_VIDEO_PROGRESS_TWENTY_SECONDS,
  KissanEventType.VIDEO_PLAY,
  KissanEventType.VIDEO_PROGRESS,
  KissanEventType.AUTOPLAY_VIDEO_STATIC_BANNER_LOADED,
  KissanEventType.AGRINEWS_AUDIO_PLAY,
  KissanEventType.AUTO_PLAY_AUDIO_PLAYONE,
  KissanEventType.AUTO_PLAY_AUDIO_PLAYTWENTY,
  KissanEventType.AUTO_PLAY_AUDIO_PLAYPROGRESS
];

const sendToBranchIoEvents = [
  KissanEventType.HOMEPAGE_LOAD_SUCCESS,
  KissanEventType.NORMAL_LOGIN_SUCCESS,
  KissanEventType.QNA_ASKSUBMIT_SUCCESS,
  KissanEventType.VIDEO_PLAY,
  KissanEventType.ITEM_LIKED,
  KissanEventType.SELECT_POST,
  KissanEventType.ITEM_COMMENT,
];

const sendToFirebaseAndFacebookEvents = [
  KissanEventType.VIEW_PRODUCT_CLICK,
  KissanEventType.PAYMENT_SUCCESS,
  KissanEventType.BUY_NOW_CLICK,
  KissanEventType.ADD_TO_CART,
  KissanEventType.CART_PAGEOPEN_SUCCESS,
];


const transformEventParams = (additionalDetails: any[] = []) => {
  if (!Array.isArray(additionalDetails)) return {};

  return additionalDetails.reduce(
    (acc, item) => {
      if (item?.refType && item?.refValue) {
        acc[item.refType] = item.refValue.refValueString ?? item.refValue.refValueInt;
      }
      return acc;
    },
    {} as Record<string, any>,
  );
};

const firebaselogEvent = (eventName, screenDetails, additionalParams = {}) => {
  // Firebase events
 logEvent(eventName, {
    ...screenDetails,
    ...additionalParams,
  });
  logFacebookEvent(eventName, (additionalParams = {}));
};

const handleUserActionEvent = () => {
logEvent('USER_ACTION', {
    screen: 'user action for ads',
  });
};
export const handleMarketingEvents = (
  eventName: any,
  screenDetails: Record<string, any>,
  additionalParams: any[] = [],
) => {
  const eventParams = transformEventParams(additionalParams);
  if (
    sendToFirebaseAndFacebookEvents.includes(eventName) ||
    sendToFirebasEvents.includes(eventName) ||
    sendToBranchIoEvents.includes(eventName)
  ) {
    firebaselogEvent(eventName, screenDetails, eventParams);
  } else {
    firebaselogEvent(eventName, screenDetails, eventParams);
    // console.log("Home page load failed called !!!");
  }

  if (sendToFirebasEvents.includes(eventName) || sendToBranchIoEvents.includes(eventName)) {
    handleUserActionEvent();
  }
};


// utils/youtubeUtils.ts
export const extractYouTubeId = (url: string): string | null => {
  if (!url) return null;

  // Check if the URL belongs to a known YouTube domain
  const isYouTube = /(youtube\.com|youtu\.be|youtube-nocookie\.com|youtubevb\.com)/i.test(url);
  if (!isYouTube) return null;

  // Extract video ID
  const match = url.match(
    /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed)\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );

  return match ? match[1] : null;
};